import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/agile";
import { random } from "lodash";
export const fragments = {
	Project: `
		fragment Project on Project {
			code
			id
      		name
		}
	`,
	ProjectDebtPagination: `
		fragment ProjectDebtPagination on ProjectDebtPagination {
			id
			amount
			customer{
				id 
				name
			}
			product{
				id
				name
			}
			paid_days
			issued_date
			debt_age
			can_update
			
		}
	`,
	ProjectDebt: `
		fragment ProjectDebt on ProjectDebt {
			id
			amount
			customer{
				id 
				name
			}
			product{
				id
				name
			}
			paid_days
			issued_date
			debt_age
			deadline_date
		}
	`
};

const ADD_PROJECT = `
	create_customer (
		name: $name, 
		code: $code,
		phone: $phone,
		email: $email, 
		state_id: $state_id,
		district_id: $district_id,
		ward_id: $ward_id,
		street: $street,
		debt_limit: $debt_limit,
		group: $group,
		description: $description,
		tag_ids: $tag_ids
	) {
		...Project
	}
`;

const UPDATE_PROJECT = `
	update_customer (
		id: $id,
		name: $name, 
		phone: $phone,
		email: $email,
		state_id: $state_id,
		district_id: $district_id,
		ward_id: $ward_id,
		street: $street,
		debt_limit: $debt_limit,
		group: $group,
		description: $description,
		tag_ids: $tag_ids
	) {
		...Project
	}
`;

const DELETE_PROJECT = `
	delete_customer (id: $id) {
		...Project
	}
`;

const GET_PROJECTS = `
	projects (limit: $limit, page: $page) {
		data {
			...Project
		}
		total
	}
`;

const SHOW_PRODUCTS = `
	show_products (limit: $limit, page: $page, search: $search) {
		data {
			id
			name
			code
			price
			can_update
			can_delete
			front_image {
				id
				path
				file_name
			}
			qty_limit
			quantity
			expired_days
		}
		total
		per_page
		current_page
	}
`;

const PROJECT_DEBTS = `
	customer_debts(limit: $limit, page: $page, customer_id: $customer_id) {
		data {
			id
			amount
			customer{
				id 
				name
			}
			product{
				id
				name
			}
			paid_days
			issued_date
			deadline_date
			debt_age
		}
		total
		per_page
		current_page
	}
`;

const CREATE_DEBT = `
	create_customer_debt (
		amount: $amount,
		product_id: $product_id,
		customer_id: $customer_id,
		delivery_code: $delivery_code,
		issued_date: $issued_date,
		paid_days: $paid_days
	) {
		...ProjectDebt

	}
`;
const UPDATE_DEBT = `
	update_customer_debt (
		amount: $amount,
		id: $id
	) {
		...ProjectDebt

	}`;

const DELETE_DEBT = `
	delete_customer_debt(id: $id) {
		...ProjectDebt
	}
`;
const DETAIL_DEBT = `
	customer_debt(id: $id) {
		...ProjectDebt
	}
`;

const EXPORT_PROJECT_DEBTS_HTML = `
	export_customer_debts_html (to_month: $to_month, to_year: $to_year) {
		name
		display
	}
`;

const GET_PROJECT = `
	customer (id: $id) {
		...Project
	}
`;

const IMPORT_PROJECTS = `
	import_projects(file: $file) {
		id
		type
		content
		display
	}
`;

const IMPORT_PROJECT_DEBTS = `
	import_customer_debts(file: $file) {
		id
		type
		content
		display
	}
`;

const EXPORT_PROJECT_DEBTS_FILE = `
	export_customer_debts
`;

const PROJECT_MULTIPLE_UPDATE_PERMISSIONS = `
	customer_multiple_update_permissions(
		customer_ids: $customer_ids,
		content: $content,
		objects: $objects) 
`;

const ACCCESSABLE_FIELDS = `
	acccessable_fields(model_name:"Project"){
		display
		name
	}
`;
const PIPELINES = `pipelines (limit: $limit, page: $page) {
    total
    current_page
    data{
		id 
		name
		can_update
		can_delete
		sort_order
		code
    }
  }`;
const ADD_PIPELINE = `
	add_pipeline(
		code: $code,
		name: $name
	) {
		id 
		name
		can_update
		can_delete
		sort_order
		code
	}
  `;
const UPDATE_PIPELINE = `
  update_pipeline(
	  id: $id,
	  code: $code,
	  name: $name
  ) {
	  id
	  name
	  sort_order
  }
`;
const DELETE_PIPELINE = `
	delete_pipeline(
		id: $id
	)
  `;
const SORT_PIPELINE = `
  	sort_pipeline(
		ids: $ids
	)
  `;
const ADD_PRODUCT = `
	create_product(
		code: $code,
		name: $name,
		price: $price,
		front_image: $front_image,
		description: $description,
		expired_days: $expired_days,
		quantity: $quantity,
		qty_limit: $qty_limit
	) {
		id
		name
		code
		price
		can_update
		can_delete
		front_image {
			id
			path
			file_name
		}
		qty_limit
		quantity
		expired_days
	}
  `;
const UPDATE_PRODUCT = `
	update_product(
	  	id: $id,
	  	code: $code,
	  	name: $name,
	  	price: $price,
		front_image: $front_image,
		description: $description,
		expired_days: $expired_days,
		quantity: $quantity,
		qty_limit: $qty_limit
	) {
		id
		name
		code
		price
		can_update
		can_delete
		front_image {
			id
			path
			file_name
		}
		qty_limit
		quantity
		expired_days
  }
`;
const DELETE_PRODUCT = `
	delete_product(
		id: $id
	)
  `;

const INPUT_PRODUCT_QUANTITY = `
	input_product_quantity(file_upload: $file_upload, step: $step) 
`;
const CREATE_PRODUCT_STOCK = `
	create_product_stock(
		product_id: $product_id, 
		inventory_id: $inventory_id,
		lot_number: $lot_number,
		imported_at: $imported_at,
		quantity: $quantity,
		expired_days: $expired_days,
		bin: $bin,
		imported_to: $imported_to
	)
	  {
		id
		product {
			name
			id
		}
		imported_at
		lot_number
		quantity
		expired_days
		bin
		inventory {
			id
			name
		}
	}`;

const UPDATE_PRODUCT_STOCK = `
	update_product_stock(
		id: $id,
		product_id: $product_id,
		inventory_id: $inventory_id,
		lot_number: $lot_number,
		imported_at: $imported_at,
		quantity: $quantity,
		expired_days: $expired_days,
		bin: $bin,
		imported_to: $imported_to) {
			id
			product {
				name
				id
			}
			imported_at
			lot_number
			quantity
			expired_days
			bin
			inventory {
				id
				name
			}

	}
`;

const PRODUCT_STOCKS = `
	product_stocks(page: $page, limit: $limit, product_id: $product_id, search: $search) {
		data {
			id
			product {
				name
				id
			}
			imported_at
			lot_number
			quantity
			expired_days
			bin
			inventory {
				id
				name
			}
			imported_to
		}
		total
	}`;
const EXPORT_PRODUCT_STOCK = `export_product_stock(id: $id){id quantity}`;
const DELETE_PRODUCT_STOCK = `delete_product_stock(id: $id)`;
const PRODUCT = `product(id: $id) {
	id
	name
	code
	price
	can_update
	can_delete
	front_image {
		id
		path
		file_name
	}
	qty_limit
	quantity
	expired_days
}`;
export default {
	init() {},
	fetchProjects(payload) {
		const queryOptions = {
			query: gql`query Project ($limit: Int!, $page: Int!) {
				${GET_PROJECTS}
			}
			${fragments.Project}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				projects: response.data.projects.data,
				total: response.data.projects.total
			};
		});
	},

	addProject(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectManagementCreate (
					$name: String!, 
					$code: String, 
					$email: String!,
					$phone: String!,
					$state_id: Int,
					$district_id: Int,
					$ward_id: Int,
					$street: String,
					$debt_limit: Int,
					$group: String,
					$description: String,
					$tag_ids: [Int]
					) {
						${ADD_PROJECT}
					}
					${fragments.Project}
				`,
				variables: {
					name: payload.name,
					code: payload.code,
					email: payload.email,
					phone: payload.phone,
					state_id: payload.state_id || null,
					district_id: payload.district_id || null,
					ward_id: payload.ward_id || null,
					street: payload.street || "",
					debt_limit: payload.debt_limit || null,
					group: payload.group || "",
					description: payload.description || "",
					tags_id: payload.tags_id || []
				}
			})
			.then(response => response.data.create_customer);
	},

	updateProject(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectManagementUpdate (
					$id: Int!,
					$name: String!, 
					$email: String!,
					$phone: String!,
					$state_id: Int,
					$district_id: Int,
					$ward_id: Int,
					$street: String,
					$debt_limit: Int,
					$group: String,
					$description: String,
					$tag_ids: [Int]
					) {
						${UPDATE_PROJECT}
					}
					${fragments.Project}
				`,
				variables: {
					id: payload.id,
					name: payload.name,
					email: payload.email,
					phone: payload.phone,
					state_id: payload.state_id || null,
					district_id: payload.district_id || null,
					ward_id: payload.ward_id || null,
					street: payload.street || "",
					debt_limit: payload.debt_limit || null,
					group: payload.group || "",
					description: payload.description || "",
					tag_ids: payload.tag_ids || []
				}
			})
			.then(response => response.data.update_customer);
	},

	deleteProject(customerId) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectManagementDelete ($id: Int!) {
					${DELETE_PROJECT}
				}
				${fragments.Project}
			`,
				variables: {
					id: customerId
				}
			})
			.then(response => response.delete_customer);
	},
	fetchShowProducts(payload) {
		const queryOptions = {
			query: gql`query ShowProducts ($limit: Int!, $page: Int!, $search: String) {
				${SHOW_PRODUCTS}
			}
			`,
			variables: {
				limit: payload ? payload.limit || -1 : -1,
				page: payload ? payload.page || 1 : -1,
				search: payload ? payload.search || "" : ""
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				products: response.data.show_products.data,
				total: response.data.show_products.total
			};
		});
	},
	createDebt(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectCreateDebt (
					$amount: Float,
					$product_id: Int,
					$customer_id: Int,
					$delivery_code: String,
					$issued_date: DateTime,
					$paid_days: Int
				) {
					${CREATE_DEBT}
				}
				${fragments.ProjectDebt}
			`,
				variables: {
					amount: payload ? payload.amount || null : null,
					product_id: payload ? payload.product_id || null : null,
					customer_id: payload ? payload.customer_id || null : null,
					delivery_code: payload ? payload.delivery_code || null : null,
					issued_date: payload ? payload.issued_date || null : null,
					paid_days: payload ? payload.paid_days || 0 : 0
				}
			})
			.then(response => response.data.create_customer_debt);
	},
	updateDebt(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectUpdateDebt (
					$amount: Float,
					$id: Int
				) {
					${UPDATE_DEBT}
				}
				${fragments.ProjectDebt}
			`,
				variables: {
					amount: payload ? payload.amount || null : null,
					id: payload ? payload.id || null : null
				}
			})
			.then(response => response.delete_customer_debt);
	},
	deleteDebt(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectDeleteDebt ($id: Int!) {
					${DELETE_DEBT}
				}
				${fragments.ProjectDebt}
			`,
				variables: {
					id: payload ? payload.debtId : null
				}
			})
			.then(response => response.delete_customer_debt);
	},
	detailDebt(payload) {
		const queryOptions = {
			query: gql`query DetailDebt ($id: Int!) {
				${DETAIL_DEBT}
			}
			${fragments.ProjectDebt}
			`,
			variables: {
				id: payload ? payload.id || -1 : -1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				customer_debt: response.data.customer_debt
			};
		});
	},
	getProjectDebtPaginations(payload) {
		const queryOptions = {
			query: gql`query ProjectDebtPaginations ($limit: Int!, $page: Int!, $customer_id: Int) {
				${PROJECT_DEBTS}
			}

			`,
			variables: {
				limit: payload ? payload.limit || -1 : -1,
				page: payload ? payload.page || 1 : -1,
				customer_id: payload ? payload.customer_id || 1 : -1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				customer_debts: response.data.customer_debts.data,
				total: response.data.customer_debts.total
			};
		});
	},
	exportProjectData(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportProjectData ($to_year: Int, $to_month: Int) {
					${EXPORT_PROJECT_DEBTS_HTML}
				}
			`,
				variables: {
					to_year: payload ? payload.to_year || null : null,
					to_month: payload ? payload.to_month || null : null
				}
			})
			.then(response => response.data.export_customer_debts_html);
	},
	getProjectDetail(payload) {
		const queryOptions = {
			query: gql`query ProjectDetail ($id: Int) {
				${GET_PROJECT}
			}
			${fragments.Project}
			`,
			variables: {
				id: payload ? payload.id || -1 : -1
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				customer: response.data.customer
			};
		});
	},
	importProject(file) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ImportProject ($file: Int!) {
					${IMPORT_PROJECTS}
				}
			`,
				variables: {
					file: file
				}
			})
			.then(response => response.data.import_projects);
	},
	importProjectDebts(file) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ImportProjectDebts ($file: Int!) {
					${IMPORT_PROJECT_DEBTS}
				}
			`,
				variables: {
					file: file
				}
			})
			.then(response => response.data.import_customer_debts);
	},
	downloadProjectDebtsFile() {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportProjectDebtsFile {
					${EXPORT_PROJECT_DEBTS_FILE}
				}
			`
			})
			.then(response => response.data.export_customer_debts);
	},
	customerMultipleUpdatePermissions(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectMultipleUpdatePermissions (
					$customer_ids: [Int],
					$content: String,
					$objects: [IdTypeInput]
				) {
					${PROJECT_MULTIPLE_UPDATE_PERMISSIONS}
				}
			`,
				variables: {
					customer_ids: payload ? payload.customer_ids || [] : [],
					content: payload ? payload.content || "" : "",
					objects: payload ? payload.objects || [] : []
				}
			})
			.then(response => response.customer_multiple_update_permissions);
	},
	getProjectAcccessableFields() {
		const queryOptions = {
			query: gql`query ProjectAcccessableFields {
				${ACCCESSABLE_FIELDS}
			}
			`
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				acccessable_fields: response.data.acccessable_fields
			};
		});
	},
	pipelines(payload) {
		const queryOptions = {
			query: gql`query ProjectPipelines ($limit: Int!, $page: Int!) {
				${PIPELINES}
			}
			`,
			variables: {
				limit: payload ? payload.limit || -1 : -1,
				page: payload ? payload.page || 1 : 1
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				pipelines: response.data.pipelines.data,
				total: response.data.pipelines.total
			};
		});
	},
	addPipeline(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectAddPipeline (
					$code: String!,
					$name: String!
				) {
					${ADD_PIPELINE}
				}
			`,
				variables: {
					name: payload ? payload.name || "" : "",
					code: payload ? payload.code || `CUSTYPE${random(1, 100)}` : `CUSTYPE${random(1, 100)}`
				}
			})
			.then(response => response.data.add_pipeline);
	},
	updatePipeline(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectUpdatePipeline (
					$code: String!,
					$id: Int!,
					$name: String!
				) {
					${UPDATE_PIPELINE}
				}
			`,
				variables: {
					name: payload ? payload.name || "" : "",
					id: payload ? payload.id || null : null,
					code: payload ? payload.code || "" : ""
				}
			})
			.then(response => response.data.update_pipeline);
	},
	deletePipeline(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectDeletePipeline (
					$id: Int!
				) {
					${DELETE_PIPELINE}
				}
			`,
				variables: {
					id: payload ? payload.id || null : null
				}
			})
			.then(response => response.delete_pipeline);
	},
	sortPipeline(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectSortPipeline (
					$ids: [Int!]
				) {
					${SORT_PIPELINE}
				}
			`,
				variables: {
					ids: payload ? payload.ids || [] : []
				}
			})
			.then(response => response.sort_pipeline);
	},
	addProduct(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectAddProduct (
					$code: String!,
					$price: Float,
					$front_image: Int!,
					$name: String!,
					$description: String!,
					$expired_days: Int, 
					$quantity: Int,
					$qty_limit: Int
				) {
					${ADD_PRODUCT}
				}
			`,
				variables: {
					name: payload ? payload.name || "" : "",
					description: payload ? payload.description || "" : "",
					code: payload ? payload.code || null : null,
					price: payload ? payload.price || 0 : 0,
					front_image: payload ? payload.front_image || 0 : 0,
					expired_days: payload ? payload.expired_days || 0 : 0,
					quantity: payload ? payload.quantity || 0 : 0,
					qty_limit: payload ? payload.qty_limit || 0 : 0
				}
			})
			.then(response => response.data.create_product);
	},
	updateProduct(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectUpdateProduct (
					$code: String!,
					$id: Int!,
					$price: Float,
					$front_image: Int!,
					$name: String!,
					$description: String!,
					$expired_days: Int,
					$quantity: Int,
					$qty_limit: Int

				) {
					${UPDATE_PRODUCT}
				}
			`,
				variables: {
					name: payload ? payload.name || "" : "",
					id: payload ? payload.id || null : null,
					code: payload ? payload.code || "" : "",
					price: payload ? payload.price || 0 : 0,
					front_image: payload ? payload.front_image || 0 : 0,
					description: payload ? payload.description || "" : "",
					expired_days: payload ? payload.expired_days || 0 : 0,
					quantity: payload ? payload.quantity || 0 : 0,
					qty_limit: payload ? payload.qty_limit || 0 : 0
				}
			})
			.then(response => response.data.update_product);
	},
	deleteProduct(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ProjectDeleteProduct (
					$id: Int!
				) {
					${DELETE_PRODUCT}
				}
			`,
				variables: {
					id: payload ? payload.id || null : null
				}
			})
			.then(response => response.delete_product);
	},
	importProductQuantity(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ImportProductQuantity($file_upload: Int!, $step: Int) {
					${INPUT_PRODUCT_QUANTITY}
				}
			`,
				variables: {
					file_upload: payload.file_upload,
					step: payload.step
				}
			})
			.then(response => response.data.input_product_quantity);
	},
	createProductStock(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CreateProductStock(
					$product_id: Int!, 
					$inventory_id: Int!, 
					$lot_number: String!,
					$imported_at: DateTime!,
					$quantity: Int!,
					$expired_days: Int!,
					$bin: String,
					$imported_to: DateTime
				) {
					${CREATE_PRODUCT_STOCK}
				}
			`,
				variables: {
					product_id: payload.product_id ? payload.product_id : 0,
					inventory_id: payload.inventory_id ? payload.inventory_id : 0,
					lot_number: payload.lot_number ? payload.lot_number : "",
					imported_at: payload.imported_at ? payload.imported_at : "",
					quantity: payload.quantity ? payload.quantity : 0,
					expired_days: payload.expired_days ? payload.expired_days : 0,
					bin: payload.bin ? payload.bin : "",
					imported_to: payload.imported_to ? payload.imported_to : ""
				}
			})
			.then(response => response.data.create_product_stock);
	},
	updateProductStock(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateProductQuantity(
					$id: Int!,
					$product_id: Int!,
					$inventory_id: Int!,
					$lot_number: String!,
					$imported_at: DateTime!,
					$quantity: Int!,
					$expired_days: Int!,
					$bin: String,
					$imported_to: DateTime
				) {
					${UPDATE_PRODUCT_STOCK}
				}
			`,
				variables: {
					id: payload.id ? payload.id : null,
					product_id: payload.product_id ? payload.product_id : 0,
					inventory_id: payload.inventory_id ? payload.inventory_id : 0,
					lot_number: payload.lot_number ? payload.lot_number : "",
					imported_at: payload.imported_at ? payload.imported_at : "",
					quantity: payload.quantity ? payload.quantity : 0,
					expired_days: payload.expired_days ? payload.expired_days : 0,
					bin: payload.bin ? payload.bin : "",
					imported_to: payload.imported_to ? payload.imported_to : ""
				}
			})
			.then(response => response.data.update_product_stock);
	},
	getListProductStocks(payload) {
		const queryOptions = {
			query: gql`query ProductStocks ($limit: Int!, $page: Int!, $product_id: Int, $search: String) {
				${PRODUCT_STOCKS}
			}
			`,
			variables: {
				limit: payload ? payload.limit || -1 : -1,
				page: payload ? payload.page || 1 : 1,
				product_id: payload ? payload.product_id || null : null,
				search: payload ? payload.search || "" : ""
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return {
				product_stocks: response.data.product_stocks.data,
				total: response.data.product_stocks.total
			};
		});
	},
	exportProductStock(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation ExportProductStock ($id: Int) {
					${EXPORT_PRODUCT_STOCK}
				}`,
				variables: {
					id: id
				}
			})
			.then(response => response.data.export_product_stock);
	},
	deleteProductStock(id) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation DeleteProductStock ($id: Int) {
					${DELETE_PRODUCT_STOCK}
				}`,
				variables: {
					id: id
				}
			})
			.then(response => response.data.delete_product_stock);
	},
	getProductItem(id) {
		const queryOptions = {
			query: gql`query ProductStocks ($id: Int!) {
				${PRODUCT}
			}
			`,
			variables: {
				id: id
			}
		};
		return graphqlClient.query(queryOptions).then(response => {
			return response.data.product;
		});
	}
};
